import React from 'react'
import Control from '../store/control';
import Param from '../store/param';

import FormModeling from './formModeling';
import FormSetup from './formSetup';

const SideForm = () => {
  const activeStep = Param.Get('activeStep');

  switch (activeStep) {
    case 0:
      return <FormSetup/>;
    case 1:
      return <p>No implementation as for now. Please skip it</p>;
    case 2:
      return <FormModeling/>;
    default:
      return 'Unknown step';
  }
}

export default SideForm;
